<template>
  <div id="component-loading">
    <div class="loading-spinner"></div>
    <div>{{ message }}</div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  data() {
    return {
      message: 'Carregando...',
      arrMessage: [
        'Verificando seus dados de admissão...',
        'Validando informações cadastrais...',
        'Estamos processando seu envio de documentos...',
        'Estamos preparando tudo para você...',
        'Estamos quase terminando...',
        'Estamos carregando...',
        'Estamos quase lá...',
        'Estamos quase prontos...',
        'Estamos quase finalizando...',
        'Estamos quase concluindo...',
      ]
    }
  },
  methods: {
    randomMessage() {
      setInterval(() => {
        this.message = this.arrMessage[Math.floor(Math.random() * this.arrMessage.length)]
      }, 7000)
    },
  },
  mounted() {
    this.randomMessage()
  }

}
</script>

<style lang="scss">
.loading-spinner {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #fa4616;
  ;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  margin: 0 auto;
  animation: spin 2s linear infinite;
}

#component-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;

  display: flex;
  align-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
}



@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
